import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackAddToCart } from '../utils/pixel';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-182">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-sage/20 shadow-[0_-10px_40px_rgba(0,0,0,0.1)] z-50 md:hidden flex items-center justify-between gap-4" data-id="element-183">
          <div className="flex flex-col" data-id="element-184">
            <span className="text-xs text-charcoal/60 uppercase tracking-wider font-bold" data-id="element-185">
              Total
            </span>
            <span className="font-serif text-xl font-bold text-charcoal" data-id="element-186">
              $14.97
            </span>
          </div>
          <a href="https://www.plenavital.com/cart/48387544416481:1" target="_top" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="bg-terracotta text-white font-sans font-semibold py-3 px-6 rounded-full shadow-md flex-1 text-center text-sm" data-id="element-187">
            QUIERO MI RESET
          </a>
        </motion.div>}
    </AnimatePresence>;
}